module.exports = __webpack_public_path__ + "img/partner18.81bd7614.png";